import * as Sentry from '@sentry/vue'
import { useRouter } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()
  const config = useRuntimeConfig()

  // Only initialize Sentry if DSN is provided
  if (!config.public.sentryDsn) {
    console.warn('Sentry DSN not configured')
    return
  }

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: config.public.sentryDsn,
    
    // Environment configuration
    environment: config.public.sentryEnvironment || 'development',
    
    // Performance monitoring
    integrations: [
      Sentry.browserTracingIntegration({
        router,
        routeLabel: 'name',
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    
    // Performance Monitoring
    tracesSampleRate: config.public.sentryEnvironment === 'production' ? 0.1 : 1.0,
    
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    
    // Release tracking
    release: config.public.appVersion || undefined,
    
    // User privacy
    sendDefaultPii: true, // Set to false if you don't want to send default PII data
    
    // Error filtering
    beforeSend(event, hint) {
      // Filter out specific errors if needed
      if (event.exception) {
        const error = hint.originalException
        
        // Don't send network errors in development
        if (config.public.sentryEnvironment === 'development' && error?.message?.includes('Network')) {
          return null
        }
        
        // Add user context if available
        const authStore = useAuth()
        if (authStore?.user) {
          event.user = {
            id: authStore.user.id,
            email: authStore.user.email,
            username: authStore.user.name,
          }
        }
      }
      
      return event
    },
    
    // Breadcrumb filtering
    beforeBreadcrumb(breadcrumb) {
      // Filter out noisy breadcrumbs if needed
      if (breadcrumb.category === 'console' && breadcrumb.level === 'debug') {
        return null
      }
      return breadcrumb
    },
  })

  // Provide Sentry to the app
  nuxtApp.provide('sentry', Sentry)
  
  // Log initialization
  console.log('Sentry initialized for environment:', config.public.sentryEnvironment || 'development')
})